import "../styles/loading.css"

export const Loading = () => {
    return (
        <div className="loading-style">
            <span className="loading loading-spinner loading-lg"></span>
        </div>
    );
};